import properties from "./properties";
import utils from "./utils";

export default {
  data:()=>({
    strength: 0,
    showPassword: false,
    showOldPassword: false,
    passwordNotEmailPart: false,
    passwordNotAllowed: false,
    passwordRules: {
      contains: {
        letters: false,
        upperLetters: false,
        lowerLetters: false,
        numbers: false,
        symbols: false,
      },
      lengthBetween: false,
    },
  }),
  computed:{
    isPasswordFollowingRules: function () {
      return this.$c('show_new_password_policy')?(
        Object.values(this.passwordRules.contains).filter((valid) => valid)
          .length >= 4 && this.passwordRules.lengthBetween
      ):(
        Object.values(this.passwordRules.contains).filter((valid) => valid)
          .length >= 3 && this.passwordRules.lengthBetween
      );
    },
  },
  methods: {

    passwordReplace(id, touch=false){
      this.form[id] = utils.replacePasswordCharacters(this.form[id]);
      if(touch){
        this.touchPassword(id);
      }
    },
     //touching form function
     touchPassword(fieldName) {
      this.v$.form[fieldName].$touch();

      //check password rules
      if (fieldName == "password") {
        this.passwordChanged();
      }

     
      if (this.form.password) {
        
        //check if password not allowed
        if (this.form.password.match(properties.REGEXP.ONLY_ALLOWED)) {
          this.passwordNotAllowed = false;
        } else {
          this.passwordNotAllowed = true;
          this.passwordNotEmailPart = false;
        }

        //check if email contains password
        let email = (this.form && this.form.email) || (this.user && this.user.email)
        if (email) {
          if (email.includes(this.form.password)) {
            this.passwordNotEmailPart = true;
            this.passwordNotAllowed = false;
          } else {
            this.passwordNotEmailPart = false;
          }
        }


      }
    },
    passwordChanged: function () {
      if (this.form.password) {
        //check password rules

        this.strength = 0;

        if(this.$c("show_new_password_policy")){
          this.checkNewPassowrdRules();
        }else{
          this.checkOldPasswordRules();
        }
      } else {
        //reset custom password errors
        this.passwordNotEmailPart = false;
        this.passwordNotAllowed = false;
      }
    },
    checkNewPassowrdRules: function(){
      if (this.form.password.match(properties.REGEXP.LOWER_LETTERS_REGEXP)) {
        this.passwordRules.contains.lowerLetters = true;
        this.strength = this.strength + 20;
      } else {
        this.passwordRules.contains.lowerLetters = false;
      }

      if (this.form.password.match(properties.REGEXP.UPPER_LETTERS_REGEXP)) {
        this.passwordRules.contains.upperLetters = true;
        this.strength = this.strength + 20;
      } else {
        this.passwordRules.contains.upperLetters = false;
      }

      if (this.form.password.match(properties.REGEXP.NUMBER_REGEXP)) {
        this.passwordRules.contains.numbers = true;
        this.strength = this.strength + 20;
      } else {
        this.passwordRules.contains.numbers = false;
      }

      if (this.form.password.match(properties.REGEXP.SYMBOL_REGEXP)) {
        this.passwordRules.contains.symbols = true;
        this.strength = this.strength + 20;
      } else {
        this.passwordRules.contains.symbols = false;
      }

      if (this.form.password.length >= 10 && this.form.password.length <= 40) {
        this.passwordRules.lengthBetween = true;
        this.strength = this.strength + 20;
      } else {
        this.passwordRules.lengthBetween = false;
      }
    },
    checkOldPasswordRules: function(){
      if (this.form.password.match(properties.REGEXP.LETTERS_REGEXP)) {
        this.passwordRules.contains.letters = true;
        this.strength = this.strength + 25;
      } else {
        this.passwordRules.contains.letters = false;
      }

      if (this.form.password.match(properties.REGEXP.NUMBER_REGEXP)) {
        this.passwordRules.contains.numbers = true;
        this.strength = this.strength + 25;
      } else {
        this.passwordRules.contains.numbers = false;
      }

      if (this.form.password.match(properties.REGEXP.SYMBOL_REGEXP)) {
        this.passwordRules.contains.symbols = true;
        this.strength = this.strength + 25;
      } else {
        this.passwordRules.contains.symbols = false;
      }

      if (this.form.password.length >= 8 && this.form.password.length <= 40) {
        this.passwordRules.lengthBetween = true;
        this.strength = this.strength + 25;
      } else {
        this.passwordRules.lengthBetween = false;
      }
    },
  }
};


